import { render, staticRenderFns } from "./NavBarConfig.vue?vue&type=template&id=2ac94872&"
import script from "./NavBarConfig.vue?vue&type=script&lang=js&"
export * from "./NavBarConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports